module.exports = __webpack_public_path__ + "img/process-icon3.a5b64dd8.png";